import React, { useMemo } from 'react';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import {
    CAMPUS_ID_BERLIN,
    CAMPUS_ID_BUENOS_AIRES,
    CAMPUS_ID_HONG_KONG,
    CAMPUS_ID_SANTA_ROSA,
    CAMPUS_ID_VANCOUVER,
} from '../../shared/js/constants';
import { BEM_BLOCK_NAME } from '../constants';
import BERLIN_DE from './berlin.de';
import BERLIN_EN from './berlin.en';
import BUENOS_AIRES_EN from './buenosAires.en';
import BUENOS_AIRES_ES from './buenosAires.es';
import HONG_KONG_EN from './hongKong.en';
import HONG_KONG_ZH_HANT from './hongKong.zh-Hant';
import SANTA_ROSA_EN from './santaRosa.en';
import VANCOUVER_EN from './vancouver.en';
import VANCOUVER_ZH_HANT from './vancouver.zh-Hant';

type PropTypes = {
    campaignName: string;
    campusId: number;
    locale: string;
};

const useStyles = makeStyles(({ spacing }) => ({
    root: {
        marginTop: spacing(2),
    },
}));

function InternationalGivingInstructions({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    campaignName,
    campusId,
    locale,
}: PropTypes) {
    const classes = useStyles();
    const rootClassNames = ClassNames(`${BEM_BLOCK_NAME}--intl_giving_instructions`, classes.root);

    const instructions = useMemo(() => {
        switch (campusId) {
            case CAMPUS_ID_BERLIN:
                return locale.startsWith('de') ?
                    (<BERLIN_DE campaignName={campaignName} />) :
                    (<BERLIN_EN campaignName={campaignName} />);

            case CAMPUS_ID_BUENOS_AIRES:
                return locale.startsWith('es') ?
                    (<BUENOS_AIRES_ES campaignName={campaignName} />) :
                    (<BUENOS_AIRES_EN campaignName={campaignName} />);

            case CAMPUS_ID_HONG_KONG:
                return locale.startsWith('zh') ?
                    (<HONG_KONG_ZH_HANT campaignName={campaignName} />) :
                    (<HONG_KONG_EN campaignName={campaignName} />);

            case CAMPUS_ID_SANTA_ROSA:
                return (<SANTA_ROSA_EN campaignName={campaignName} />);

            case CAMPUS_ID_VANCOUVER:
                return locale.startsWith('zh') ?
                    (<VANCOUVER_ZH_HANT campaignName={campaignName} />) :
                    (<VANCOUVER_EN campaignName={campaignName} />);

            default:
                return (<div>ERROR - UNHANDLED INTERNATIONAL GIVING CASE</div>);
        }
    }, [
        campaignName,
        campusId,
        locale,
    ]);

    return (
        <div className={rootClassNames}>
            {instructions}
        </div>
    );
}

export default InternationalGivingInstructions;
